import {
  MIME_TYPE_FORM_DATA_MULTIPART,
  MIME_TYPE_MERGE_PATCH_JSON,
} from "@rumble-it/common-lib/src/constants/mimeTypes";
import { axiosInstance } from "../client";
import { Company } from "@rumble-it/common-lib/types/models/Company.interface";
import { CollectionResponse } from "@rumble-it/common-lib/types/api/CollectionResponse.interface";
import { PaginationParams } from "@rumble-it/common-lib/types/api/PaginationParams.interface";
import { CompanyEditValues } from "../../../pages/admin/companies/CompanyEdit";

export interface CompanyQueryParams extends PaginationParams {
  type?: string;
}

export const fetchCompanies = async (
  params: CompanyQueryParams,
): Promise<CollectionResponse<Company>> =>
  axiosInstance.get(`/companies`, { params }).then((response) => response.data);

export const createCompany = async (data: Partial<Company>): Promise<Company> =>
  axiosInstance.post(`/companies`, data).then((response) => response.data);

export const updateCompanyById = async (
  id: string,
  data: CompanyEditValues,
): Promise<null> =>
  axiosInstance
    .patch(`/companies/${id}`, data, {
      headers: { "Content-Type": MIME_TYPE_MERGE_PATCH_JSON },
    })
    .then((response) => response.data);

export const deleteCompanyById = async (id: string): Promise<null> =>
  axiosInstance.delete(`/companies/${id}`).then((response) => response.data);

export const fetchCompanyById = async (id: string): Promise<Company> =>
  axiosInstance.get(`/companies/${id}`).then((response) => response.data);

export const importCompanies = async (file: File): Promise<any> => {
  const formData = new FormData();
  formData.append("file", file);

  return axiosInstance
    .post(`/companies/import-csv`, formData, {
      headers: { "Content-Type": MIME_TYPE_FORM_DATA_MULTIPART },
    })
    .then((response) => response.data);
};
